
import SearchResult from "@/components/search/v2/SearchResult"
import sanitizeText from "@/utils/sanitize-text"
import { getJobBySlug } from "@/services/v2/job.service"
import { getBusiness } from "@/services/v2/business.service"
import { getPost } from "@/services/v2/post.service"

export default {
    name: "ManualListBlok",
    components: { SearchResult },
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
    async fetch() {
        if (!this.blok.items) return
        const items = this.blok.items.split(",").map((item) => item.trim())
        const promises = items.map(async (item) => {
            switch (this.blok.type) {
                case "traineeship":
                case "apprenticeship":
                    return this.$api.run(getJobBySlug, item).request
                case "business_site":
                    return this.$api.run(getBusiness, item).request
                case "post":
                    return this.$api.run(getPost, item).request
                default:
                    return null
            }
        })
        const resolved = await Promise.allSettled(promises)
        this.items = resolved
            .filter((item) => item.value)
            .map((item) => item.value)
    },
    data: () => ({
        items: [],
    }),
    computed: {
        category() {
            switch (this.blok.type) {
                case "post":
                    return "Neuigkeiten"
                case "apprenticeship":
                    return "Ausbildung"
                case "business":
                    return "Unternehmen"
                case "traineeship":
                    return "Praktikum"
                default:
                    return "Ausbildung"
            }
        },
        contentType() {
            if (["apprenticeship", "traineeship"].includes(this.blok.type))
                return "job"
            if (this.blok.type === "region-post") return "post"
            if (this.blok.type === "business_site") return "business"
            return this.blok.type
        },
        rows() {
            if (this.blok.mobileRows && this.$breakpoint.smAndDown)
                return parseInt(this.blok.mobileRows)
            return parseInt(this.blok.rows)
        },
    },
    methods: {
        parseText(s) {
            if (!s) return
            return sanitizeText(s).replace(/\*([^*]+?)\*/g, "<b>$1</b>")
        },
    },
}
